import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface BloodBankHomeCounts {
  totalBloodUnits: number;
  expiringSoonUnits: number;
  transitRecords: number;
}

export interface BloodTypeDistribution {
  data: Array<{ blood_group: string; count: number }>;
  total: number;
}

export interface TwoWeekDonationStats {
  thisWeekCount: number;
  lastWeekCount: number;
  difference: number;
  percentChange: number | null;
  byBloodGroup: Array<{ blood_group: string; count: number }>;
  mostDonatedThisWeek: { blood_group: string; count: number } | null;
  leastDonatedThisWeek: { blood_group: string; count: number } | null;
}

export const bloodBankHomeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBloodBankCounts: builder.query<BloodBankHomeCounts, void>({
      query: () => "/blood-bank-home/counts",
      transformResponse: (res: ApiResponse<BloodBankHomeCounts>) => res.data,
      providesTags: ["BloodBankHome"],
    }),
    getBloodTypeDistribution: builder.query<BloodTypeDistribution, void>({
      query: () => "/blood-bank-home/blood-type-distribution",
      transformResponse: (res: ApiResponse<BloodTypeDistribution>) => res.data,
      providesTags: ["BloodBankHome"],
    }),
    getTwoWeekDonationStats: builder.query<TwoWeekDonationStats, void>({
      query: () => "/blood-bank-home/donations-two-weeks",
      transformResponse: (res: ApiResponse<TwoWeekDonationStats>) => res.data,
      providesTags: ["BloodBankHome"],
    }),
  }),
});

export const { useGetBloodBankCountsQuery, useGetBloodTypeDistributionQuery, useGetTwoWeekDonationStatsQuery } = bloodBankHomeApi;
